var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.policies['view-tuition-fee-month'])?_c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Đối soát theo tháng","link":[
            { text: 'Tài chính', href: '#' },
            { text: 'Đối soát theo tháng', href: '#' }
          ]}})],1)]),_c('v-card',{staticClass:"mx-4 mb-6 elevation-0",attrs:{"outlined":""}},[_c('ListMonth')],1)],1):_c('div',[_c('Page403')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }